import { render, staticRenderFns } from "./admins.vue?vue&type=template&id=f62f906a&"
import script from "./admins.vue?vue&type=script&lang=js&"
export * from "./admins.vue?vue&type=script&lang=js&"
import style0 from "./admins.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports